<template>
    <div class="mycity">
            <div class="sitebox">
                +添加配送地址
            </div>
              <el-form :model="recipient" size="mini" :rules="rules" ref="recipient" class="demo-ruleForm" @submit.native.prevent>
                 <div class="lableName">
                    <p>称谓</p><span class="el-icon-arrow-down"></span>
                  </div>
                <el-form-item prop="name">
                  <el-input onkeyup="this.value=this.value.replace(/\s+/g,'')" v-model="recipient.name" placeholder="*姓名"></el-input>
                </el-form-item>
                <el-form-item prop="sheng" class="city">
                  <el-select v-model="recipient.sheng" @change="choseProvince" placeholder="*省份">
                    <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <el-select v-model="recipient.shi" @change="choseCity" placeholder="*城市" >
                    <el-option v-for="item in shi1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                  <el-select v-model="recipient.qu" @change="choseBlock" placeholder="*区域">
                    <el-option v-for="item in qu1" :key="item.value" :label="item.label" :value="item.value"></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item prop="addressDetails">
                  <el-input v-model="recipient.addressDetails" placeholder="*详细地址"></el-input>
                </el-form-item>
                  <el-form-item prop="id" style="display: none">
                    <el-input v-model="recipient.id"></el-input>
                  </el-form-item>
                <el-form-item prop="Zipcode">
                  <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model="recipient.Zipcode" placeholder="*邮编"></el-input>
                </el-form-item>
                    <el-form-item prop="tel">
                  <el-input onkeyup="this.value=this.value.replace(/\D+/g,'')" v-model.number="recipient.tel" placeholder="*联系电话"></el-input>
                </el-form-item>
                <div class="check_box">
                  <input type="checkbox" class="tui-checkbox" :checked="recipient.status==1"  :value="recipient.status" v-model="recipient.status"><span>设为默认地址</span>
                </div>
              </el-form>
              <div v-if="this.$route.query.id == 1 || this.$route.query.city == 2" class="btn" @click="recipientSubmitForm('recipient')">确认添加地址</div>
              <div v-if="this.$route.query.id == 2" class="btn" @click="postEditAddress('recipient')">修改地址</div>
              <p class="quxiao"> <router-link :to="{ name:'Information', query: {id: 1} }">取消</router-link></p>
    </div>
</template>

<script>
  import {regionData} from 'element-china-area-data';
  import {create_address_url,edit_address_url} from '../request/api'

export default {
    name: 'NewLiuyanShopWebAddcity',
    data() {
    let validateName = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("姓名不能为空！"));
        } else {
          const reg = /^[\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("格式不正确"));
          }
        }
      };
        let validatePhone = (rule, value, callback) => {
        if (!value) {
          return callback(new Error("号码不能为空！"));
        } else {
          const reg = /^1([38][0-9]|4[579]|5[0-3,5-9]|6[6]|7[0135678]|9[389])\d{8}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error("请输入正确的手机号"));
          }
        }
      };
       let recipientZipCode = (rule, value, callback) => {
        if (!value) {
          // return callback(new Error('邮编不能为空！'))
          callback();//邮编可为空
        } else {
          const reg = /^[0-9][0-9]{5}$/;
          if (reg.test(value)) {
            callback();
          } else {
            return callback(new Error('邮政编码格式不正确！'));
          }
        }
      };
        return {
        cur:0,
        checked:'',
        istitle:'新增地址',
        orderslist:'myinfo',
        allOrder: [],
        completeOrder: [],
        unfinishedOrder: [],
        options: regionData,
        cityIndex: 0,
        xianIndex: 0,
        shi: '市级地区',
        qu: '县级地区',
        shi1: [],
        qu1: [],
        formData: '',
        addressData: [],
        addAddressForm: false,
        editorAddressForm: false,
        // 我的信息form
    
        rules: {
          userName: [{validator: validateName, trigger: "blur"}],
          name: [
            {required: true, message: '请输入收货人姓名', trigger: 'blur'},
            {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
          ],
          // recipients: [
          //   {required: true, message: '请输入收货人姓名', trigger: 'blur'},
          //   {min: 1, max: 20, message: '长度在 1 到 20 个字符', trigger: 'blur'}
          // ],
          tel: [
            {required: true, validator: validatePhone, trigger: 'blur'},
          ],
          phone: [
            {required: true, validator: validatePhone, trigger: 'blur'},
          ],
          sheng: [
            {required: true, message: '请选择收货地址', trigger: 'change'},
          ],
          addressDetails: [
            {required: true, message: '请输入详细地址', trigger: 'blur'},
            {min: 3, max: 99, message: '长度在 3 到 99 个字符', trigger: 'blur'}
          ],
          area: [
            {required: true, message: '请输入详细地址', trigger: 'blur'},
            {min: 3, max: 99, message: '长度在 3 到 99 个字符', trigger: 'blur'}
          ],
          Zipcode: [
            {required: false, validator: recipientZipCode, trigger: 'blur'},
          ],
          postcode: [
            {required: false, validator: recipientZipCode, trigger: 'blur'},
          ],
        },
        //添加收货地址
        recipient: {
          name: '',
          tel: '',
          city: '',
          addressDetails: '',
          Zipcode: '',
          sheng: '',
          shi: '',
          qu: '',
          E: '',
          id:'',
          status:''
        },
        edit_recipient: {
          id: '',
          recipients: '',
          phone: '',
          area: '',
          postcode: '',
          sheng: '',
          shi: '',
          xian: '',
          E: '',
        },
        value2: ""
      };
    },

    mounted() {
        if(this.$route.query.city == 2){
          this.$cookies.remove('Citylist')
        }
        this.recipient.name = this.$cookies.get('Citylist').recipients
        this.recipient.sheng = this.$cookies.get('Citylist').sheng
        this.recipient.shi = this.$cookies.get('Citylist').shi
        this.recipient.qu = this.$cookies.get('Citylist').xian
        this.recipient.addressDetails = this.$cookies.get('Citylist').area
        this.recipient.tel = this.$cookies.get('Citylist').phone
        this.recipient.id = this.$cookies.get('Citylist').id
        this.recipient.status = this.$cookies.get('Citylist').status
        if(this.$route.query.id == 1){
            this.recipient.name = ''
            this.recipient.sheng = ''
            this.recipient.shi = ''
            this.recipient.qu = ''
            this.recipient.addressDetails = ''
            this.recipient.tel = ''
            this.recipient.id = ''
            this.recipient.status = ''
        }
    },

    methods: {
         // 提交收货地址form
      recipientSubmitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.$store.state.isLogin) {
              this.$router.push({path: '/login'});
            } else {
              let addressdata = {
                recipients: this.recipient.name,
                phone: this.recipient.tel,
                sheng: this.recipient.sheng,
                shi: this.recipient.shi,
                xian: this.recipient.qu,
                area: this.recipient.addressDetails,
                postcode: this.recipient.Zipcode,
                status:this.recipient.status == true ? 1 : 0
              };
              this.createAddress(addressdata);
            }
          } else {
            return false;
          }
        });
      },
      // 修改地址
      postEditAddress(formName){
        this.$refs[formName].validate((valid) => {
          if (valid) {
            if (!this.$store.state.isLogin) {
              this.$router.push({path: '/login'});
            } else {
              let addressdata = {
                recipients: this.recipient.name,
                phone: this.recipient.tel,
                sheng: this.recipient.sheng,
                shi: this.recipient.shi,
                xian: this.recipient.qu,
                area: this.recipient.addressDetails,
                postcode: this.recipient.Zipcode,
                id:this.recipient.id,
                status:this.recipient.status == true ? 1 : 0
              };
              this.editAddress(addressdata);
            }
          } else {
            return false;
          }
        });
      },
      editAddress(data) {
        edit_address_url(data).then((res)=>{
            if (res.data.code === 200) {
                 this.$router.push({path:'/Information',query:{id:1}})
            }else{
              this.$message.error('保存失败')
            }
        })
   
      },
           //创建地址
        createAddress(addressInfo) {
        create_address_url(addressInfo).then((res)=>{
            this.recipient.name = '';
            this.recipient.tel = '';
            this.recipient.sheng = '';
            this.recipient.shi = '';
            this.recipient.qu = '';
            this.recipient.addressDetails = '';
            this.recipient.Zipcode = '';
            this.shi1 = '';
            this.qu1 = '';
            this.recipient.E = '';
            this.$refs['recipient'].resetFields();
            if(res.data.code == 200){
              console.log(this.$route.query.id)
              if(this.$route.query.id == 1){
                this.$router.push({path:'/Information',query:{id:1}})
              }
               if(this.$route.query.city == 2){
                this.$router.push({path:'/ordersIn?page=s'})
              }
              
            }
        })
    
      },
          // 选省
      choseProvince: function (e) {
        for (let index2 in this.options) {
          if (e === this.options[index2].value) {
            this.recipient.sheng = this.options[index2].label;
            this.edit_recipient.sheng = this.options[index2].label;
            this.shi1 = this.options[index2].children;
            if (this.shi1 != undefined) {
              this.recipient.shi = this.options[index2].children[0].label;
              this.edit_recipient.shi = this.options[index2].children[0].label;
              this.qu1 = this.options[index2].children[0].children;
              if (this.qu1 != undefined) {
                this.recipient.qu = this.options[index2].children[0].children[0].label;
                this.edit_recipient.xian = this.options[index2].children[0].children[0].label;
                this.recipient.E = this.qu1[0].value;
              } else {
                this.recipient.E = this.recipient.qu = '';
                this.edit_recipient.E = this.edit_recipient.qu = '';
                this.qu = '下方输入详细地址'
              }
            } else {
              this.recipient.E = this.recipient.qu = this.recipient.shi = '';
              this.edit_recipient.E = this.edit_recipient.xian = this.edit_recipient.shi = '';
              this.shi = this.qu = '下方输入详细地址'
            }
            this.cityIndex = index2;
          }
        }
      },
      // 选市
      choseCity: function (e) {
        for (var index3 in this.options[this.cityIndex].children) {
          if (e === this.options[this.cityIndex].children[index3].value) {
            this.recipient.shi = this.options[this.cityIndex].children[index3].label;
            this.edit_recipient.shi = this.options[this.cityIndex].children[index3].label;
            this.qu1 = this.options[this.cityIndex].children[index3].children;
            if (this.qu1 != undefined) {
              this.recipient.qu = this.options[this.cityIndex].children[index3].children[0].label;
              this.edit_recipient.xian = this.options[this.cityIndex].children[index3].children[0].label;
              this.recipient.E = this.qu1[0].value;
            } else {
              this.recipient.E = this.recipient.qu = '';
              this.edit_recipient.E = this.edit_recipient.xian = '';
              this.qu = '下方输入详细地址'
            }
            this.xianIndex = index3;
          }
        }
      },
      // 选区
      choseBlock: function (e) {
        for (var index4 in this.options[this.cityIndex].children[this.xianIndex].children) {
          if (e === this.options[this.cityIndex].children[this.xianIndex].children[index4].value) {
            this.recipient.qu = this.options[this.cityIndex].children[this.xianIndex].children[index4].label;
            this.edit_recipient.xian = this.options[this.cityIndex].children[this.xianIndex].children[index4].label;
          }
        }
      },
    },
};
</script>

<style lang="less" scoped>
.mycity{
    margin: 0 0.4rem;
    .sitebox{
           width: 100%;
         height: 1.7rem;
         line-height: 1.7rem;
         margin-top: 0.4rem;
         font-size: 0.4rem;
         font-weight: 900;
        color: #00383F;
        
    }
    .demo-ruleForm{
          .lableName{
         height: 0.9rem;
         border: 1px solid #00383F;
         margin-bottom: 0.2rem;
         font-size: 0.3rem;
         font-weight: 900;
         line-height: 0.9rem;
         padding: 0 0.21rem;
         p{
           display: inline-block;
          float: left;
         }
         span{
           float: right;
           line-height: 0.9rem;
           font-size: 0.36rem;
         }
       }
       .check_box{
         text-align: left;
      input[type="checkbox"]{width:0.4rem;height:0.4rem;display: inline-block;text-align: center;vertical-align: middle; line-height: 18px;position: relative;}
      input[type="checkbox"]::before{content: "";position: absolute;top: 0;left: 0;background: #fff;width: 100%;height: 100%;border: 1px solid #00383F}
      input[type="checkbox"]:checked::before{content: '';width: 0.4rem;height: 0.4rem;background:#fff url("../../static/mobile/duihao.png") no-repeat;background-size: 0.4rem 0.4rem;}

         span{
           font-size: 0.3rem;
           font-weight: 900;
          vertical-align: middle;
          margin-left: 0.2rem;
         }
       }
    }
        /deep/.el-select{
            width: 100%;
        }
          /deep/.el-select:nth-child(2){
            margin: 0.2rem 0;
        }
        /deep/.el-input--mini .el-input__inner {
            height: 0.9rem;
            font-size: 0.3rem;
        }
        /deep/.el-input__inner::placeholder{
            text-align: left;
            font-size: 0.3rem;
            color:#00383F ;
        }
        /deep/.el-select .el-input .el-select__caret{
          font-size: 0.36rem;
          color: #00383F;
        }
        /deep/.el-input__suffix{
          right:0.2rem;
          display: inline-block;
        }
        /deep/.el-input__suffix-inner{
          width: 0.36rem;
        }
        /deep/.el-input--mini .el-input__icon {
          line-height: 0.9rem;
        }
        /deep/.el-input--mini .el-input__inner{
          padding-right:unset ;
        }
        /deep/.el-form-item{
          margin-bottom: 0.2rem;
        }
        .btn{
          width: 100%;
          height: 0.9rem;
          background: #00383F;
          font-size: 0.36rem;
          line-height: 0.9rem;
          color: #fff;
          font-weight: 900;
          margin: 0.6rem 0 0.5rem 0;
        }
        .quxiao{
          margin-bottom: 1rem;
          a{
            font-size: 0.36rem;
            font-weight: 900;
            color: #00383F;
          }
        }
}
</style>


// WEBPACK FOOTER //
// src/view/Addcity.vue